import { Layout, LayoutProps } from 'react-admin';
import { CustomAppBar } from './components';

export const CustomLayout = (props: LayoutProps) => <Layout appBar={CustomAppBar} {...props} />;
